import { getUserConfiguration } from 'owa-session-store';
import { OwaDate, startOfYear, startOfMonth, subDays, subWeeks, startOfWeek } from 'owa-datetime';

export function getStartOfWeek(date: OwaDate) {
    const userStartOfWeek = getUserConfiguration().UserOptions.WeekStartDay;
    return startOfWeek(date, userStartOfWeek);
}

export function getStartOfLastWeek(date: OwaDate) {
    return subWeeks(getStartOfWeek(date), 1);
}

export function getEndOfLastWeek(date: OwaDate) {
    return subDays(getStartOfWeek(date), 1);
}

export function getStartOfLastMonth(date: OwaDate) {
    return startOfMonth(getEndOfLastMonth(date));
}

export function getEndOfLastMonth(date: OwaDate) {
    return subDays(startOfMonth(date), 1);
}

export function getStartOfLastYear(date: OwaDate) {
    return startOfYear(getEndOfLastYear(date));
}

export function getEndOfLastYear(date: OwaDate) {
    return subDays(startOfYear(date), 1);
}
